// 优先展示本笔账变的真实来源，历史缺失字段不拼接空分隔符。
export function orderBalanceTitle(change) {
  const sourceName = String(change.sourceName || '').trim();
  return [sourceName || change.stage, change.accountName, change.currency]
    .map(value => String(value || '').trim())
    .filter(Boolean)
    .join(' · ');
}

// 同账户、同币种已有最终处理记录时，仅展示最终变动，避免将冻结理解为重复扣款。
export function visibleOrderBalanceChanges(changes) {
  if (!Array.isArray(changes)) return [];
  return changes.filter(change => change.stage !== '申请冻结' || !changes.some(candidate =>
    ['出款扣账', '提款解冻'].includes(candidate.stage) &&
    candidate.accountName === change.accountName && candidate.currency === change.currency
  ));
}
